import ModelsPortfolio from '@/Core.Service.Domain/Analytics/Models/Views';
import ModelCreateView from '@/modules/analytics/analytics_models/_components/Create';
import ModelEditView from '@/modules/analytics/analytics_models/_components/Edit';

const ModelsRoute = {
  path: 'models/all',
  name: 'Models',
  component: ModelsPortfolio,
  meta: {
    placeholder: 'Search for a Model',
    analyticsTypeName: 'AnalyticsModel',
    label: 'Models',
    buttonLabel: 'New Model',
    toolTip: 'Model',
    permission: 'analytics:read',
  },
};

const ModelCreateRoute = {
  path: 'models/create-model/site/:siteId',
  name: 'ModelCreate',
  component: ModelCreateView,
};

const ModelEditRoute = {
  path: 'models/edit-model/:id',
  name: 'ModelEdit',
  component: ModelEditView,
};

export { ModelCreateRoute, ModelEditRoute, ModelsRoute };

